import { useState, useEffect } from 'react'

import { getCookie, setCookie } from 'cookies-next'

const useCookie = (key, defaultValue, options = {}) => {
  const [value, setValue] = useState(() => {
    let currentValue

    if (typeof window === 'undefined') {
      // Server-side
      currentValue = getCookie(key, options) || String(defaultValue)
    } else {
      // Client-side
      try {
        currentValue = getCookie(key) || String(defaultValue)
      } catch {
        currentValue = defaultValue
      }
    }

    return currentValue
  })

  useEffect(() => {
    setCookie(key, value, options)
  }, [value, key, options])

  return [value, setValue]
}

export default useCookie
